import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { decrementHttpCount, incrementHttpCount } from '../store/actions';
import { finalize } from 'rxjs';

export const requestCountInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store);
  setTimeout(() => {
    store.dispatch(incrementHttpCount());
  });
  return next(req).pipe(finalize(() => store.dispatch(decrementHttpCount())));
};
